// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5075) return "static/chunks/5075-e6b3231cb20645d0.js";
	if (chunkId === 3716) return "static/chunks/3716-dfff319b22a97470.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"277":"0e42d455a2f2aef1","6313":"46c76325c42077d2"}[chunkId] + ".js";
};